import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import "../App.css";

const API = "https://slimlinehardwarefittings.com/backend";

export default function BlogDetails() {

  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {

    setLoading(true);

    axios
    axios.get(`${API}/single-blog.php?slug=${slug}`)
      .then((res) => {

        const data = res.data;

        // safe check
        if (!data || data.message) {
          setError(data?.message || "Blog nahi mila");
          setBlog(null);
        } else {
          setBlog(data);
          setError("");
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError("Blog nahi mila");
        setBlog(null);
        setLoading(false);
      });

  }, [slug]);

  if (loading) {
    return (
      <h2 style={{ padding: "40px" }}>
        Loading...
      </h2>
    );
  }

  if (error) {
    return (
      <h2 style={{ padding: "40px", color: "red" }}>
        {error}
      </h2>
    );
  }

  return (
    <div className="blog-detail-page">

     <img
  src={
    blog.image
      ? `https://slimlinehardwarefittings.com/backend/uploads/${blog.image}`
      : "https://via.placeholder.com/300"
  }
  alt={blog?.title}
  className="detail-image"
/>

      <h1 className="detail-title">
        {blog?.title}
      </h1>

      <div className="blog-meta">

        {blog?.category && (
          <span>{blog.category}</span>
        )}

        {blog?.tags && (
          <span>{blog.tags}</span>
        )}

      </div>

      <div
        className="blog-content"
        dangerouslySetInnerHTML={{
          __html: blog?.content || ""
        }}
      />

    </div>
  );
}